import { useEffect, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

const EMPLOYMENT_LABEL = {
  P: "Permanent",
  C: "Contractual",
  D: "Daily Wages",
  M: "MTS",
  T: "Temporary Basis",
  O: "Out Sourced",
  V: "Visiting",
  F: "Department Fund",
  G: "Guest Faculty"
};

const STATUS_LABEL = {
  W: "Working",
  R: "Retired",
  E: "Extended Service",
  X: "Expired",
  H: "Emeritus"
};

export default function Directory() {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [filters, setFilters] = useState({
    selectedDepartmentID: "1000",
    selectedDesignationID: "1000",
    selectedEmpType: "All",
    selectedJobType: "All",
    selectedStatus: "All",
    selectedEmpName: ""
  });

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const [deptRes, desigRes] = await Promise.all([
          fetch(`${API_ROOT}/api/meta/departments`),
          fetch(`${API_ROOT}/api/meta/designations`)
        ]);

        const deptData = await deptRes.json();
        const desigData = await desigRes.json();

        if (!deptRes.ok) throw new Error(deptData.message || "Failed to fetch departments");
        if (!desigRes.ok) throw new Error(desigData.message || "Failed to fetch designations");

        setDepartments(Array.isArray(deptData) ? deptData : []);
        setDesignations(Array.isArray(desigData) ? desigData : []);
      } catch (err) {
        setError(err.message || "Failed to load filters");
      }
    };

    loadFilters();
  }, []);

  const displayEmpList = async () => {
    try {
      setLoading(true);
      setError("");

      const params = new URLSearchParams(filters);
      const res = await fetch(`${API_ROOT}/api/directory/employees?${params.toString()}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to load employee list");
      }

      setRows(Array.isArray(data) ? data : []);
    } catch (err) {
      setRows([]);
      setError(err.message || "Failed to load employee list");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container-fluid">
      <h3 className="mb-3">Directory</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="row g-3 align-items-end">
        <div className="col-lg-3 col-md-6">
          <label className="form-label">Department</label>
          <select
            className="form-control"
            value={filters.selectedDepartmentID}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedDepartmentID: e.target.value }))}
          >
            <option value="1000">Display All Department</option>
            {departments.map((d) => (
              <option key={d.DepartmentID} value={d.DepartmentID}>{d.Department}</option>
            ))}
          </select>
        </div>

        <div className="col-lg-2 col-md-6">
          <label className="form-label">Designation</label>
          <select
            className="form-control"
            value={filters.selectedDesignationID}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedDesignationID: e.target.value }))}
          >
            <option value="1000">Display All Designations</option>
            {designations.map((d) => (
              <option key={d.DesignationID} value={d.DesignationID}>{d.Designation}</option>
            ))}
          </select>
        </div>

        <div className="col-lg-1 col-md-4">
          <label className="form-label">Emp Type</label>
          <select
            className="form-control"
            value={filters.selectedEmpType}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedEmpType: e.target.value }))}
          >
            <option value="All">All</option>
            <option value="T">Teaching</option>
            <option value="N">Non-Teaching</option>
            <option value="A">Academic Staff</option>
          </select>
        </div>

        <div className="col-lg-1 col-md-4">
          <label className="form-label">Job Type</label>
          <select
            className="form-control"
            value={filters.selectedJobType}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedJobType: e.target.value }))}
          >
            <option value="All">All</option>
            <option value="P">Permanent</option>
            <option value="C">Contractual</option>
            <option value="D">Daily Wages</option>
            <option value="M">MTS</option>
            <option value="T">Temporary Basis</option>
            <option value="O">Out Sourced</option>
            <option value="V">Visiting</option>
            <option value="F">Department Fund</option>
            <option value="G">Guest Faculty</option>
          </select>
        </div>

        <div className="col-lg-1 col-md-4">
          <label className="form-label">Status</label>
          <select
            className="form-control"
            value={filters.selectedStatus}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedStatus: e.target.value }))}
          >
            <option value="All">ALL</option>
            <option value="W">Working</option>
            <option value="R">Retired</option>
            <option value="E">Extended Service</option>
            <option value="X">Expired</option>
            <option value="H">Emeritus</option>
          </select>
        </div>

        <div className="col-lg-2 col-md-6">
          <label className="form-label">Search by Name</label>
          <input
            className="form-control"
            value={filters.selectedEmpName}
            onChange={(e) => setFilters((prev) => ({ ...prev, selectedEmpName: e.target.value }))}
          />
        </div>

        <div className="col-lg-1 col-md-6">
          <label className="form-label">View</label>
          <button className="form-control btn btn-primary" type="button" onClick={displayEmpList} disabled={loading}>
            {loading ? "..." : "View"}
          </button>
        </div>
      </div>

      <div className="table-responsive mt-4">
        <table className="table table-bordered table-striped">
          <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
            <tr>
              <th>SNo</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Department</th>
              <th>BloodGrp</th>
              <th>Employment</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {!rows.length && (
              <tr>
                <td colSpan={9} className="text-center text-muted">
                  {loading ? "Loading..." : "No records found."}
                </td>
              </tr>
            )}
            {rows.map((row, idx) => (
              <tr key={`${row.EmpName}-${row.Mobile}-${idx}`}>
                <td>{idx + 1}</td>
                <td>{row.EmpName}</td>
                <td>{row.Designation}</td>
                <td>{row.Mobile}</td>
                <td>{row.Email}</td>
                <td style={{ width: "250px", whiteSpace: "normal", wordWrap: "break-word" }}>{row.Department}</td>
                <td>{row.BloodGroup}</td>
                <td>{EMPLOYMENT_LABEL[row.JobType] || ""}</td>
                <td>{STATUS_LABEL[row.Status] || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
